<template>
    <div>
		<div class="nTop" id="toTop" style="background-color:#FFF;">
		  <div class="wrapper clearfix">
		    <a class="logo">
		      <img src="../../assets/images/logo.jpg" alt="佰吉宏安国际能源有限公司" />
		      <h1>佰吉宏安国际能源有限公司</h1>
		    </a>
		    <a class="nt-link" @click="yanzheng('/main')">
		      <img src="../../assets/images/ico01.png" />
		      <span>个人中心</span>
		    </a>
		  </div>
		</div>
		
		<div class="header">
		  <div class="wrapper clearfix">
		    <div class="nav clearfix">
		      <!-- <router-link  to="/about">关于我们</router-link> -->
		      <a @click="tabIndex(1, '/home')" :class="keyIndex == 1 ? 'active' : ''">首页</a>
		      <a @click="tabIndex(2, '/about')" :class="keyIndex == 2 ? 'active' : ''">关于我们</a>
		      <a @click="tabIndex(3, '/honor')" :class="keyIndex == 3 ? 'active' : ''">资质荣誉</a>
		      <a @click="tabIndex(4, '/product')" :class="keyIndex == 4 ? 'active' : ''">主营产品</a>
		      <a @click="tabIndex(5, '/bidding')" :class="keyIndex == 5 ? 'active' : ''">招标信息</a>
		      <a @click="tabIndex(6, '/partner')" :class="keyIndex == 6 ? 'active' : ''">合作伙伴</a>
		      <a @click="tabIndex(7, '/news')" :class="keyIndex == 7 ? 'active' : ''">新闻资讯</a>
		      <a @click="tabIndex(8, '/contact')" :class="keyIndex == 8 ? 'active' : ''">联系我们</a>
		    </div>
		    <div class="dl-an clearfix" v-if="isLogin">
		      <a @click="toPage('/login')">
		        <img src="../../assets/images/ico02.png" />
		        <span>登录</span>
		      </a>
		      <a @click="toPage('/register')">
		        <img src="../../assets/images/ico03.png" />
		        <span>注册</span>
		      </a>
		    </div>
		  </div>
		</div>
		
		
        <!-- 面包屑 -->
        <div class="crumbs">
            <div class="n-wrapper clearfix">
                <h3 class="colsName">招标信息</h3>
                <div class="m-crumb">
                    您当前的位置：
                    <a><router-link  to="/home">首页</router-link></a>
                    <i>></i>
                    <span>招标信息</span>
                </div>
            </div>
        </div>
        <div class="bidContent">
            <div class="n-wrapper clearfix">
                <div class="clearfix">
                    <div class="b-left">
                        <div class="pic"><img :src="biddingDetail.image_uri" alt="" /></div>
                        <div class="b-statistics">
                            <p>
                                {{ biddingDetail.bm_count }}
                                <small>人报名</small>
                            </p>
                        </div>
                    </div>
                    <div class="b-right">
                        <h5 class="tit" style="text-align: left;">{{ biddingDetail.name }}</h5>
                        <p class="price"  style="margin-bottom: 0px;">
                            起拍价
                            <b>
                                <small>￥</small>
                                {{ biddingDetail.price }}
                            </b>
                        </p>
						<p class="price" style="margin-top: 0px;" v-if="biddingDetail.is_bm == 1 && biddingDetail.status_txt == '进行中'">
						    最高出价金额
						    <b>
						        <small>￥</small>
						        {{ (biddingDetail.bond_money * 100) / biddingDetail.bond}}
						    </b>
						</p>
                        <div class="b-box1">
                            <div class="startTime" v-if="biddingDetail.status_txt == '已结束'">
                                <img src="../../assets/images/ico13.png" class="ico" />
                                <p class="txt">竞拍已结束</p>
                                <div class="date">
                                    <span>00</span>
                                    天
                                    <span>00</span>
                                    时
                                    <span>00</span>
                                    分
                                    <span>00</span>
                                    秒
                                </div>
                            </div>
							<div class="startTime" v-else-if="biddingDetail.status_txt == '进行中'">
							    <img src="../../assets/images/ico13.png" class="ico" />
							    <p class="txt">距离结束时间</p>
							    <div class="date">
							        <span>{{ day }}</span>
							        天
							        <span>{{ hour }}</span>
							        时
							        <span>{{ minus }}</span>
							        分
							        <span>{{ miao }}</span>
							        秒
							    </div>
							</div>
                            <div class="startTime" v-else>
                                <img src="../../assets/images/ico13.png" class="ico" />
                                <p class="txt">距离开始时间</p>
                                <div class="date">
                                    <span>{{ day }}</span>
                                    天
                                    <span>{{ hour }}</span>
                                    时
                                    <span>{{ minus }}</span>
                                    分
                                    <span>{{ miao }}</span>
                                    秒
                                </div>
                            </div>
                            <div class="b1-cont" v-if="biddingDetail.status_txt == '未开始' || biddingDetail.status_txt == '进行中'">
                                <p class="ts ts-no" v-if="biddingDetail.status_txt == '未开始'">即将开始</p>

                                <p class="ts ts-start" v-if="biddingDetail.status_txt == '进行中'">进行中</p>
                                <div class="b1-item clearfix">
                                    <label>会员编号</label>
                                    <div class="pp" style="text-align: left;">{{ biddingDetail.member_no }}</div>
                                </div>
                                <!-- b1-item-start  活动开始class -->
                                <!-- <div class="b1-item b1-item-start clearfix"> -->
                                <div class="b1-item clearfix" style="display: flex;align-items: center;">
                                    <label style="margin-right: 20px;">出价</label>
                                    <div class="pp">
                                        <div class="b1Bor cjPrice">
                                            <p style="text-align: left;">{{ priceAndton }}</p>
                                            <!-- <input type="hidden" value="" /> -->
                                            <span class="plus" @click="edit('add')">+</span>
                                            <span class="minus" @click="edit('del')">-</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- b1-item-start  活动开始class -->
                                <!-- <div class="b1-item b1-item-start clearfix"> -->
                                <div class="b1-item clearfix" style="display: flex;align-items: center;">
                                    <label style="margin-right: 20px;">数量</label>
                                    <div class="pp" style="display: flex;align-items: center;">
                                        <div class="b1Bor amount">
                                            <input type="text" v-model="ton" @input="amount()" />
                                            <p>吨</p>
                                        </div>
                                        <p style="padding-left: 20px;font-size: 16px;">
                                            总价
                                            <span style="color:#c00;font-size: 28px;">￥{{ allPrice }}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="b1-item clearfix" v-if="isToken">
                                    <div class="pp">
                                      <!--  <a
                                            class="b1Btn"
                                            v-if="biddingDetail.is_bm == 0 && Number(biddingDetail.balance * biddingDetail.bond) < Number(allPrice)"
                                            @click="showCz = true"
                                        >
									
                                            余额不足,请点击充值
                                        </a> -->
                                        <a
                                            class="b1Btn b1Btn-active"
											:style="{'background:' : biddingDetail.is_bm == 0 ? '#a8a8a8' : ''}"
                                            v-if="biddingDetail.is_bm == 0"
                                            @click="bzjYanZheng()"
                                        >
                                            立即报名
                                        </a>
                                        <a v-if="biddingDetail.status_txt == '未开始' && biddingDetail.is_bm == 1" class="b1Btn b1Btn-active">即将开始,等待中</a>
                                      <!--  <a v-if="biddingDetail.status_txt == '进行中' && biddingDetail.is_bm == 1" @click="offer()" class="b1Btn b1Btn-active">确定出价</a> -->
										<a
										    class="b1Btn"
										    v-if="biddingDetail.is_bm == 1 && biddingDetail.status_txt == '进行中'  && Number(biddingDetail.bond_money * 100 / biddingDetail.bond) < Number(allPrice)" 
										>
											出价大于您预缴纳的保证金
										</a>
										  <a v-if="biddingDetail.is_bm == 1 && biddingDetail.status_txt == '进行中'  && Number(biddingDetail.bond_money * 100 / biddingDetail.bond) >= Number(allPrice)" class="b1Btn b1Btn-active" @click="offer()" >确定出价</a>
                                    </div>
                                </div>
                                <div class="b1-item clearfix" v-if="!isToken" @click="toPage('/login')">
                                    <div class="pp">
                                        <p class="b1Ts">
                                            提醒：先报名交保证金再出价。如果您已经交付保证金，请
                                            <a>登录</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="b1-cont" v-if="biddingDetail.status_txt == '已结束'">
                                <!-- <div>本场竞价已结束！</div> -->
                                <div v-html="biddingDetail.message"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="b-auction" v-if="biddingDetail.status_txt == '已结束' || biddingDetail.status_txt == '进行中'">
                    <h3>竞拍记录</h3>
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="padding: 0 35px;background: #af2f24;">
                        <thead>
                            <tr>
                                <th scope="col" width="40%">会员编号</th>
                                <th scope="col" width="15%">价格（原）</th>
                                <th scope="col" width="15%">数量（吨）</th>
                                <th scope="col" width="15%">发布时间</th>
                                <th scope="col" width="15%">竞标排名</th>
                            </tr>
                        </thead>
                    </table>
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="padding: 20px 35px;background: #f3f3f3;">
                        <tr class="my" v-if="biddingDetail && biddingDetail.self_info && biddingDetail.self_info[0] && biddingDetail.self_info[0].id">
                            <td style="text-align: left;">
                                {{ biddingDetail.self_info[0].member_no }}
                                <span>我的当前排名</span>
                            </td>
                            <td>{{ biddingDetail.self_info[0].price }}</td>
                            <td>{{ biddingDetail.self_info[0].numbers }}</td>
                            <td>{{ biddingDetail.self_info[0].create_time }}</td>
                            <td>{{ biddingDetail.self_info[0].ranking }}</td>
                        </tr>
                        <tr
                            :class="{ fist: list.ranking == 1 }"
                            v-if="biddingDetail && biddingDetail.product_list && biddingDetail.product_list[0] && biddingDetail.product_list[0].id"
                            v-for="(list, index) in biddingDetail.product_list"
                            :key="index"
                        >
                            <td style="text-align: left;">
                                {{ list.member_no || '匿名' }}
                                <span v-if="list.rankin == 1">竞拍排名第一</span>
                            </td>
                            <td>{{ list.price }}</td>
                            <td>{{ list.numbers }}</td>
                            <td>{{ list.create_time }}</td>
                            <td>{{ list.ranking }}</td>
                        </tr>
                    </table>
                </div>

                <div class="b-box2 clearfix">
                    <p>总数量 (吨)：{{ biddingDetail.numbers }}</p>
                    <p>热值：{{ biddingDetail.hot }}</p>
                    <p>煤种：{{ biddingDetail.coal || '未知' }}</p>
                    <p>起拍价格：{{ biddingDetail.price }}</p>

                    <p>竞拍发布时间：{{ biddingDetail.publish_time_txt }}</p>
                    <p>竞拍开始时间：{{ biddingDetail.start_time_txt }}</p>
                    <p>竞拍结束时间 ：{{ biddingDetail.end_time_txt }}</p>
                    <p>竞拍时长：{{ biddingDetail.length_time_txt }}</p>
                    <p>发货地址：{{ biddingDetail.shopping_address }}</p>
                </div>

                <div class="b-head clearfix">
                    <a class="active">产品信息</a>
                  <!--  <a>质量标准</a>
                    <a>采购方式</a>
                    <a>保证金信息</a>
                    <a>其他附件</a>
                    <a>评标方案说明</a> -->
                </div>
                <div class="b-box3">
                    <div class="bt1">质量标准</div>
					
                    <div class="zhiliang">
                        <div class="list1">
                            <div>检验指标</div>
                            <div v-for="(item,index) in biddingDetail.detail" :key='index' :class="index % 2 != 1 ? 'active' : '' " >{{item.name}}</div>
                        </div>
                        <div class="list1">
                            <div>指标标准</div>
                            <div v-for="(item,index) in biddingDetail.detail" :key='index' :class="index % 2 != 1 ? 'active' : '' " >{{item.value}}</div>
                        </div>
                        <div class="list1" style="">
                            <div>单位</div>
                           <div v-for="(item,index) in biddingDetail.detail" :key='index'  :class="index % 2 != 1 ? 'active' : '' " >{{item.unit}}</div>
                        </div>
                    </div>
                    <div class="bt1">保证金信息</div>
                    <div class="zhiliang">
                        <div class="list1">
                            <div>公司名称：{{ footerMassage.address }}</div>
                        </div>
                        <div class="list1">
                            <div>银行账户：{{ footerMassage.bank_card }}</div>
                        </div>
                        <div class="list1" style="">
                            <div>开户银行：{{ footerMassage.bank_company_name }}</div>
                        </div>
                    </div>

                    <div class="bt1"  v-if="biddingDetail && biddingDetail.enclosure_info && biddingDetail.enclosure_info[0]" >其他附件</div>
                  <!--  <article @click="openPfd()" v-if="biddingDetail && biddingDetail.enclosure_info && biddingDetail.enclosure_info[0]">
                        {{ biddingDetail.enclosure_info[0].title }}
                    </article> -->
					<!-- @mouseenter="item.isOn ? 'active1' : ''" @mouseleave="item.isOn = false" -->
					<article @click="openPdf(item.attach_uri)" v-if="biddingDetail && biddingDetail.enclosure_info && biddingDetail.enclosure_info[0]" v-for="(item,index) in biddingDetail.enclosure_info" :key="index">
					    {{ item.title }}
					</article>
                    <div class="bt1">评标方案说明</div>
                    <article style="text-align: left;">评标方案说明:{{ footerMassage.shuoming }}</article>
                </div>
            </div>
        </div>
      

        <!-- 出价成功弹窗 -->
        <div class="succeed-popUp" v-if="offerFlg">
            <img src="../../assets/images/ico17.png" />
            <p>出价成功</p>
            <em @click="offerFlg = false" class="gb"></em>
        </div>
		
		<el-dialog
		  :visible.sync="showCz"
		  width="25%">
			<div class="pop_box">
			<div class="pop_image_box">
				<img src="../../assets/icon/m_icon10.png"></img>
				用户充值
			</div>
			  <div class="input_box">
				  <el-input placeholder="请输入充值金额"  v-model="money" >
							<template slot="append">元</template>
				  </el-input>
				  </div>
				<div class="pop_tip">
					提醒：将充值金缴纳到以下银行账户，进行审核
				</div>
				<div class="pop_address_box">
					<div class="pop_address">
						{{bank.bank_company_name}}
					</div>
					<div class="pop_address_item">
						{{bank.bank_name}}
					</div>
					<div class="pop_address_item" >
						{{bank.bank_card}}
					</div>
				</div>
				<el-upload
				  action="https://baijihongan.com/api/v1/upload"
				  list-type="picture-card"
				  :class="{disUoloadSty:noneBtnDealImg}"
				  ref="mYupload"
				   name="imgFile"
				   :on-exceed="handleExceed"
				   :limit='imageLimit'
				   :on-change="imgChange"
				   :on-success="onSuccess"
				   :on-error="onError"
				  :on-preview="handlePictureCardPreview"
				  :on-remove="handleRemove"
				  :auto-upload="true"
				  :file-list='fileList'
				  :disabled="disabled">
				  <i class="el-icon-plus"></i>
				</el-upload>
				<el-dialog :visible.sync="dialogVisible">
				  <img width="100%" :src="dialogImageUrl" alt="">
				</el-dialog>
				<div class="pop_btn" @click="checkMoney()">
				确认提交
				</div>
			</div>
		</el-dialog>
		<el-dialog
		  :visible.sync="showBz"
		  width="25%" @close='close()'>
			<div class="pop_box">
				<div class="pop_image_box" style="margin-bottom: 10px;">
					<img src="../../assets/icon/m_icon10.png"></img>
					所需缴纳保证金金额
				</div>
				<div class="bzj_box" style="color: #af2f24;">
					{{allPrice / 100 * biddingDetail.bond}}元
				  </div>
				 <!-- <div class="bzj_box" style="color: #333;font-size: 23px;">
				  	最低还需缴纳{{needPay}}元
				    </div> -->
				  <div class="pop_btn" style="font-size: 15px;font-weight: 500;" v-if="Number(balance) < Number(allPrice)" @click="showCz = true">
					  余额不足，最低还需缴纳{{needPay}}元，点击充值
				  </div>
					<div class="pop_btn" @click="baoming()" v-else>
					确认缴纳
					</div>
			</div>
		</el-dialog>
		<div class="footer">
		  <div class="wrapper">
		    <div class="f-nav">
		      <a @click="tabIndex(1, '/home')">首页</a>
		      <a @click="tabIndex(2, '/about')">关于我们</a>
		      <a @click="tabIndex(3, '/honor')">资质荣誉</a>
		      <a @click="tabIndex(4, '/product')">主营产品</a>
		      <a @click="tabIndex(5, '/bidding')">招标信息</a>
		      <a @click="tabIndex(6, '/partner')">合作伙伴</a>
		      <a @click="tabIndex(7, '/news')">新闻资讯</a>
		      <a @click="tabIndex(8, '/contact')">联系我们</a>
		    </div>
		
		    <div class="f-box flexbox">
		      <img src="../../assets/images/logo_foot.png" alt="佰吉宏安国际能源有限公司" class="logo_foot" />
		      <div class="f-center flexbox33 flexwarp" style="text-align: left;">
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico05.png" />
		          <p>联系电话：{{ footerMassage.mobile }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico06.png" />
		          <p>邮政编码：{{ footerMassage.postal }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico07.png" />
		          <p>访问量：{{ footerMassage.pageviews }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico08.png" />
		          <p>电子邮箱：{{ footerMassage.email }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico09.png" />
		          <p>公司地址：{{ footerMassage.address }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico10.png" />
		          <p>交易量：{{ footerMassage.trading_volume }}</p>
		        </div>
		      </div>
		      <div class="qrcode">
		        <img :src="footerMassage.image_id5_url" alt="" />
		        <p>扫一扫了解更多</p>
		      </div>
		    </div>
		    <div class="copyright">
		      Copyright 2021 ·版权所有 佰吉宏安国际能源有限公司
		      <a href="https://beian.miit.gov.cn" target="_blank">{{ footerMassage.site_icp }}&nbsp;{{ footerMassage.site_wabah }}</a>
		      <br />
		      建议使用1920*1080以上的屏幕分辨率和8.0以上版本的浏览器来访问本站，本站不支持IE浏览器
		    </div>
		  </div>
		</div>
		<!-- 右侧浮动 -->
		<div class="floatWindow">
		    <div class="item" @click="toPage('/announcement')">
		        <a class="ico"><img src="../../assets/images/a01.png"></a>
		        <p class="txt">公告</p>
		    </div>
		    <div class="item" @click="yanzheng('/main_news')">
				<div class="index_dot" v-if="isRed">
					
				</div>
		        <a class="ico"><img src="../../assets/images/a02.png"></a>
		        <p class="txt">消息</p>
		    </div>
			<div class="item"  @click="toPage('/bidding')">
			    <a class="ico"><img src="../../assets/images/a03.png"></a>
			    <p class="txt">竞拍</p>
			</div>
			<div class="item">
			    <a class="ico"><img src="../../assets/images/a04.png"></a>
			    <p class="txt">{{footerMassage.mobile}}</p>
			</div>
			<div class="item"  @click="toPage('/contact')">
			    <a class="ico"><img src="../../assets/images/a05.png"></a>
			    <p class="txt">{{footerMassage.address}}</p>
			</div>
		    <!-- <div class="item">
		        <a href="" target="_blank" class="ico"><img src=""></a>
		    </div> -->
		   <div class="item">
				<a class="ico Top" href="#toTop"><img src="../../assets/images/a06.png"></a>
			</div>
		</div>
    </div>
</template>

<script>
	import Utils from '../../utils/utils.js';
	var time1,time2,nowTime
export default {
    name: 'biddingDetail',
    data() {
        return {
            biddingDetail: '', //页面数据
            day: '0',
            hour: '00',
            minus: '00',
            miao: '00',
            isToken: '',
            priceAndton: 0, //每吨价格出价
            allPrice: '', //总金额
            ton: 1,
            footerMassage: '',
            websock: null,
            offerFlg: false,
			sysTime:'',
			showBz:false,//展示保证金金额
			showCz:false,//展示充值弹窗
			money:'',
			bank:'',
			dialogImageUrl: '',
			dialogVisible: false,
			disabled: false,
			imageLimit:1,
			imageId:'',
			fileList:[],
			bool:true,
			balance:0,//用户余额
			needPay:0,//需要支付
			noneBtnDealImg:false,
			keyIndex:5,
			isLogin: true,
			isRed:false,	
			onff:true
        };
    },
    mounted() {
        if (this.$getStorage('userToken')) {
            this.isToken = this.$getStorage('userToken');
        }
		document.body.scrollTop = 0
		document.documentElement.scrollTop = 0
		clearInterval(time1)
		clearInterval(time2)
		this.getBank()
        this.product_info();
        this.site_info();
        this.initWebSocket();
		//增加浏览量
		this.pageviews();
	
    },
    methods: {
		async getRed() {
			var _this = this
			if(!this.$getStorage('userToken')) return
		    let { status, message, data } = await this.$ajax('no_read_information', {
				userToken: this.$getStorage('userToken'),
		    });
		    if (status == this.SUCCESS_CODE) {
					if(data == 0){
						_this.isRed = false
					}else{
						_this.isRed = true
					}
		    } else {
		        this.$message(message);
		    }
		},
		//底部导航信息
		async site_info(idnex) {
		  this.timeIndex = idnex;
		  if (this.$getStorage('userToken')) {
		    this.isLogin = false;
		  } else {
		    this.isLogin = true;
		  }
		  let { status, message, data } = await this.$ajax('site_info', {});
		  if (status == this.SUCCESS_CODE) {
		    this.footerMassage = data;
		  } else {
		    this.$message(message);
		  }
		},
		
		yanzheng(str) {
		  var _this = this;
		  if (this.$getStorage('userToken')) {
		    _this.toPage(str);
		  } else {
		    _this.$message({
		      message: '请先登录',
		      type: 'warning'
		    });
		    _this.toPage('/login');
		  }
		},
		tabIndex(index,str){
			// this.keyIndex = index
			// window.sessionStorage.setItem('keyIndex', index);
			// this.$setStorage('lastKeyIndex',index)
			// this.$setStorage('keyIndex',index)
			
			this.$router.push({
				path: str
			});
		},
		toPage(pathName, title){
			this.$router.push({
				path: pathName,
				query: { pageTitle: title }
			});
		},
		close(){
			var _this = this
			_this.$refs['mYupload'].clearFiles();
			_this.money = ''
			_this.imageId = ''
			_this.showCz = false
			_this.showBz = false
		},
		handleExceed(){
			_this.$message({
			  message: '限传一张，请先删除列表中的图片',
			  type: 'warning'
			});
			return
		},
		imgChange(file, fileList){
		  this.noneBtnDealImg = fileList.length >= 1
		},
		onSuccess(e){
			this.imageId = e.data.id
		},
		onError(e){
			this.$message({
			  message: '上传失败！请检查网络或者图片是否为png格式',
			  type: 'warning'
			});
		},
		 handleRemove(file) {
			this.imageId = ''
			this.dialogImageUrl = ''
			this.noneBtnDealImg = false
		  },
		 handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		 },
		checkMoney(){
			var _this = this
			if(_this.money == 0){
				_this.$message({
				  message: '金额不能为0',
				  type: 'warning'
				});
				return
			}
			if(_this.money == ''){
				_this.$message({
				  message: '请输入金额',
				  type: 'warning'
				});
				return
			}
			if(isNaN(_this.money)){
			   _this.$message({
			     message: '请输入正确的金额',
			     type: 'warning'
			   });
			   return
			}
			if(!_this.money%1 !==  0){
				_this.$message({
				  message: '请输入整数金额',
				  type: 'warning'
				});
				return
			}
			if(this.imageId == ''){
				_this.$message({
				  message: '请上传凭证',
				  type: 'warning'
				});
				return
			}
			this.sendMoney()
		},
		async sendMoney() {
			var _this = this
		    let { status, message, data } = await this.$ajax('recharge', {
				userToken: this.$getStorage('userToken'),
				attaches_id:this.imageId,
				money:this.money
		   });
		    if (status == this.SUCCESS_CODE) {
					_this.$message({
					  message: '上传成功！请耐心等待审核',
					  type: 'success'
					});
					_this.$refs['mYupload'].clearFiles();
					_this.money = ''
					_this.imageId = ''
					_this.needPay = 0
					_this.showCz = false
					_this.showBz = false
					_this.noneBtnDealImg = false
		    } else {
		        this.$message(message);
		    }
		},
		async getBank() {
			var _this = this
		    let { status, message, data } = await this.$ajax('site_info', {
		    });
		    if (status == this.SUCCESS_CODE) {
				this.bank = data
		    } else {
		        this.$message(message);
		    }
		},
		openPdf(str){
		 window.open('https://baijihongan.com/' + str);
		},
		//增加浏览量
		async pageviews(idnex) {
		    let { status, message, data } = await this.$ajax('pageviews', {});
		    if (status === this.SUCCESS_CODE) {
		    } else {
		        // this.$message(message);
		    }
		},
        initWebSocket() {
            // console.log(111);
            //初始化 weosocket
            const wsuri = 'ws://www.baijihongan.com:2349/';
            //const wsuri = "ws://paimai.ccpingtai.cn:2349/";
            this.websock = new WebSocket(wsuri);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        //接收
        websocketonmessage({ data }) {
            let _this = this;
            let soketData = JSON.parse(data);
            if (soketData.type == 'pric_markup') {
                if (soketData.data == _this.$route.query.id) {
                    _this.product_info(1);
                }
            }
			if (soketData.type == 'time') {
				var time = new Date().getTime()
				time = time.toString()
				time = time.substr(0,10)
				// console.log(soketData.data )
				// console.log(time )
				if(soketData.data != time){
					clearInterval(time1)
					clearInterval(time2)
					// console.log(soketData.data )
					nowTime = soketData.data * 1000
					_this.setCountDown()
				}
			}
        },
        websocketonerror() {
            // 连接建立失败重连
            this.initWebSocket();
        },
        websocketonopen() {
            //连接建立之后执行send方法发送数据
            let actions = '成功';
            // console.log(actions);
            this.websocketsend(actions);
        },
        websocketsend(Data) {
            //数据发送
            this.websock.send(Data);
            // console.log('发送的消息：' + Data);
        },
        websocketclose(e) {
            this.initWebSocket();
            //关闭
            // console.log('断开连接', e);
        },
        //出价
        offer() {
			if(this.ton == ''){
				 this.$message.error('请填写正确的数量');
				 // _this.ton = 1
				 return
			}
			if(this.ton == 0){
				 this.$message.error('数量不能为0！');
				 // _this.ton = 1
				 return
			}
			if(this.ton < this.biddingDetail.min_number){
				 this.$message.error('数量最少为' + this.biddingDetail.min_number);
				 return
			}
			
			if( this.offerFlg == true){
			
				return
			}
            this.$ajax('offer', {
                userToken: this.$getStorage('userToken'),
                id: this.$route.query.id, //	id:'',//	字符串(string)	是
                price: this.priceAndton, //	price	字符串(string)	是
                numbers: this.ton //	numbers	字符串(string)	是
            }).then(data => {
                if (data.status == this.SUCCESS_CODE) {
                    this.offerFlg = true;
					console.log(this.onff)
                } else {
                    this.$message(data.message);
					 // this.offerFlg = false;
                }
            });
        },
        //跳转pdf
        openPfd() {
            window.location.href = 'https://baijihongan.com/' + this.biddingDetail.enclosure_info[0].attach_uri;
        },
        //计算总金额
        amount() {
			if (this.biddingDetail.is_bm == 1 && this.biddingDetail.status_txt == '未开始' ) {
			   this.$message('报名后不可修改');
			   this.ton = this.biddingDetail.min_number
			   return
			}
		
            this.allPrice = this.ton * this.priceAndton;
        },
		bzjYanZheng(){
			let _this = this;
			if(this.ton == ''){
				 this.$message.error('请填写正确的数量');
				 // _this.ton = 1
				 return
			}
			if(_this.allPrice == 0 || _this.ton == 0){
				 _this.$message.error('数量不能为0！');
				 // _this.ton = 1
				 return
			}
			if(this.ton < this.biddingDetail.min_number){
				 this.$message.error('数量最少为' + _this.biddingDetail.min_number);
				 return
			}
			if(_this.biddingDetail.bm_day == 0){
				
				var num = new Date(new Date().toLocaleDateString()).getTime()
				// console.log(num)
				// console.log(new Date().getTime())
				if(_this.biddingDetail.start_time < new Date().getTime() / 1000){
					 _this.$message.error('报名时间已截止');
					 // _this.ton = 1
					 return
				}
			}else{
				var num = new Date(new Date().toLocaleDateString()).getTime() 
				// console.log(num)
				// console.log(new Date().getTime() / 1000)
				if(num / 1000 - _this.biddingDetail.bm_day * 24 * 60 * 60 < new Date().getTime() / 1000 ){
					 _this.$message.error('报名时间已截止');
					 // _this.ton = 1
					 return
				}
			}			
			
			if(Number(_this.ton > _this.biddingDetail.numbers / 2)){
				 _this.$message.error('不可超过总数量的50%');
				 // _this.ton = 1
				 return
			}
			_this.$ajax('getInfo', {
				userToken: _this.$getStorage('userToken'), //	userToken	字符串(string)	是
			}).then(data => {
					if (data.status == _this.SUCCESS_CODE) {
						_this.balance = data.data.balance
						_this.needPay = (_this.allPrice / 100 * _this.biddingDetail.bond)  - _this.balance
						
						if(_this.balance < _this.allPrice / 100 * _this.biddingDetail.bond){
							_this.$ajax('add_bond_log', {
							    userToken: _this.$getStorage('userToken'), //	userToken	字符串(string)	是
								price:_this.priceAndton,
								numbers: _this.ton,
								product_id:_this.$route.query.id
							}).then(res => {
								if (res.status == _this.SUCCESS_CODE) {
									  _this.money = _this.needPay
									  _this.showBz = true
								} else {
									_this.$message.error(res.message);
								}
							})
							
						}else{
							var str =  '将缴纳' + _this.allPrice / 100 * _this.biddingDetail.bond + '元保证金,您确定吗'
							_this.$confirm(str, '提示', {
							  confirmButtonText: '确定',
							  cancelButtonText: '取消',
							  type: 'warning'
							}).then(() => {
								_this.baoming()
							}).catch(() => {
							});
						}
					} else {
						_this.$message.error(data.message);
					}
			})
		},
        //未开始交保证金
        async baoming() {
            let _this = this;
            let { status, message, data } = await _this.$ajax('pay_bond', {
                userToken: _this.$getStorage('userToken'), //	userToken	字符串(string)	是
                id: _this.$route.query.id, //	id	字符串(string)	是
                price: _this.allPrice / 100 * _this.biddingDetail.bond, //	price	字符串(string)	是
                numbers: _this.ton //	numbers	字符串(string)	是
            });
            if (status == this.SUCCESS_CODE) {
                if (status == 0) {
					_this.$message({
					  message: '保证金缴纳成功！请耐心等待竞拍开始',
					  type: 'success'
					});
					  // = _this.priceAndton 
					  _this.ton = _this.biddingDetail.min_number
					  clearInterval(time1)
					  clearInterval(time2)
                    _this.product_info();
                }
            } else {
                _this.$message.error(message);
            }
        },


        //信息
        product_info(type) {
		
            this.$ajax('product_info', {
                userToken: this.$getStorage('userToken'), //	userToken	字符串(string)	是
                id: this.$route.query.id, //	id	字符串(string)	是
            }).then(data => {
                if (data.status == this.SUCCESS_CODE) {
					data.data.enclosure_info.forEach(item=>{
						item.isOn = false
					})
					this.biddingDetail = data.data;
					this.priceAndton = this.biddingDetail.max_price
					
				
					// nowTime = new Date().getTime(); //现在时间
					//0未开始  1 已开始 2 已结束
					let _this = this;
					if(!type){
						_this.ton = _this.biddingDetail.min_number
						_this.allPrice = _this.priceAndton * _this.ton;
						nowTime = new Date().getTime()
						_this.setCountDown()
					}else{
						_this.amount()
					}
					_this.$ajax('getInfo', {
						userToken: _this.$getStorage('userToken'),
					})
					.then(data => {
						if (data.status == _this.SUCCESS_CODE) {
							if(data.type == 2){
								_this.$message.error('个人用户无法参与竞拍！请去个人中心修改');
								 _this.$router.go(-1);
							}
						} else {
							_this.$message.error(data.message);
						}
					});
					if(_this.biddingDetail.is_bm == 0 && _this.biddingDetail.status_txt == '未开始'){
						_this.getNmPrice()
					}
                }else if(data.status == -2){
					data.data.enclosure_info.forEach(item=>{
						item.isOn = false
					})
					this.biddingDetail = data.data;
					this.priceAndton = this.biddingDetail.max_price
					 // nowTime = new Date().getTime(); //现在时间
					//0未开始  1 已开始 2 已结束
					let _this = this;
					if(!type){
						_this.ton = _this.biddingDetail.min_number
						_this.allPrice = _this.priceAndton * _this.ton;
						nowTime = new Date().getTime()
						_this.setCountDown()
					}else{
						_this.amount()
					}
					// if(_this.biddingDetail.is_bm == 0 && _this.biddingDetail.status_txt == '未开始'){
					// 	_this.getNmPrice()
					// }
					if(_this.$getStorage('userToken')){
						_this.$ajax('getInfo', {
							userToken: _this.$getStorage('userToken'),
						})
						.then(data => {
							if (data.status == _this.SUCCESS_CODE) {
								if(data.type == 2){
									_this.$message.error('个人用户无法参与竞拍！请去个人中心修改');
									 _this.$router.go(-1);
								}
							} else {
								_this.$message.error(data.message);
							}
						});
					}else{
						_this.$confirm('您需要登录才可进行操作', '提示', {
						  confirmButtonText: '确定',
						  cancelButtonText: '取消',
						  type: 'warning'
						}).then(() => {
						  _this.$router.push({
						      path: "/login"
						  });
						}).catch(() => {
						     _this.$router.go(-1);  
						});
					}
					
				}else if(data.status == -1){
					data.data.enclosure_info.forEach(item=>{
						item.isOn = false
					})
					this.biddingDetail = data.data;
					this.priceAndton = this.biddingDetail.max_price
					 // nowTime = new Date().getTime(); //现在时间
					//0未开始  1 已开始 2 已结束
					let _this = this;
					if(!type){
						_this.ton = _this.biddingDetail.min_number
						_this.allPrice = _this.priceAndton * _this.ton;
						nowTime = new Date().getTime()
						_this.setCountDown()
					}else{
							_this.amount()
					}
					// if(_this.biddingDetail.is_bm == 0 && _this.biddingDetail.status_txt == '未开始'){
					// 	_this.getNmPrice()
					// }
					_this.$alert('当前竞拍已经开始！未报名禁止进入', '提示', {
						   confirmButtonText: '确定',
						   showClose:false,
						   callback: action => {
							  _this.$router.go(-1);
						   }
						});
				}
				 else {
                    this.$message(data.message);
                }
            });
        },
		//保证金记录  
		async getNmPrice(idnex) {
			var that = this
		    let { status, message, data } = await this.$ajax('edit_bond_log', {
				userToken: this.$getStorage('userToken'), //	userToken	字符串(string)	是
				product_id: this.$route.query.id, //	id	字符串(string)	是
			});
		    if (status == this.SUCCESS_CODE) {
		        // console.log(data)
				if(data){
					that.priceAndton = data.price
					that.ton = data.numbers
					that.allPrice = that.ton * that.priceAndton;
				}
		    } else {
		        this.$message(message);
		    }
		},
		setCountDown(){
			let _this = this;
			
			if(_this.biddingDetail.status_txt == '未开始'){
				time1 = setInterval(function() {
				    _this.daojishi = _this.countDown(_this.biddingDetail.start_time * 1000);
				}, 1000);
			}
			if(_this.biddingDetail.status_txt == '进行中'){
				time2 = setInterval(function() {
				    _this.daojishi = _this.countDown(_this.biddingDetail.end_time * 1000);
				}, 1000);
			}
		},
        //加
        edit(str) {
			if (this.biddingDetail.is_bm == 1 && this.biddingDetail.status_txt == '未开始' ) {
			   this.$message('报名后不可修改');
			   return
			}
            if (str == 'add') {
                this.priceAndton = this.priceAndton + this.biddingDetail.pric_markup;
            } else {
                if (!this.priceAndton == 0 && this.priceAndton > this.biddingDetail.price) {
                    this.priceAndton = this.priceAndton - this.biddingDetail.pric_markup;
                } else {
                    this.$message('不能低于底价');
                }
            }
            this.amount();
        },
        countDown(time) {
            --time; //时间一秒秒的减
			var that = this
            // nowTime = new Date().getTime(); //现在时间
            if (nowTime < time) {
                //获取时间差
                let timediff = Math.round((time - nowTime) / 1000);
                //获取还剩多少天
                let day = parseInt(timediff / 3600 / 24);
                //获取还剩多少小时
                let hour = parseInt((timediff / 3600) % 24);
                //获取还剩多少分钟
                let minute = parseInt((timediff / 60) % 60);
                //获取还剩多少秒
				nowTime = nowTime + 1000
                let second = timediff % 60;
                this.day = day;
                this.hour = hour < 10 ? '0' + hour : hour;
                this.minus = minute < 10 ? '0' + minute : minute;
                this.miao = second < 10 ? '0' + second : second;
                // return (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute) + ':' + (second < 10 ? '0' + second : second);
            } else  {
				if(that.biddingDetail.status_txt == '未开始'){
					clearInterval(time1)
					clearInterval(time2)
					 that.product_info();
					 return
				}else if(that.biddingDetail.status_txt == '进行中'){
					that.product_info();
					clearInterval(time1)
					clearInterval(time2)
					// that.$router.push({
					// 	path: '/bidding'
					// });
					
					return
				}
			
				// this.product_info();
				// clearInterval(that.daojishi)?
                return;
			}
        }
    }
};
</script>

<style>
.zhiliang {
    display: flex;
    text-align: left;
    padding-bottom: 60px;
}
.list1 {
    flex: 1;
}
.list1 div {
    line-height: 45px;
    padding-left: 40px;
}
.active1 {
    background: #f4f4f4;
}
.crumbs {
    background: #ffffff;
}
/* 招标详情 */
.bidContent {
    wdith: 100%;
    padding: 35px 0 90px;
	background-color: #fff;
}
.bidContent .b-left {
    width: 45.956%;
    float: left;
}
.bidContent .b-right {
    width: 48.897%;
    float: right;
}

.bidContent .pic {
    width: 100%;
    height: 480px;
    margin-bottom: 25px;
}
.bidContent .b-statistics {
    border: 1px solid #dbdbdb;
    height: 48px;
    text-align: center;
    line-height: 46px;
    overflow: hidden;
}
.bidContent .b-statistics p {
    width: 100%;
    float: left;
    font-size: 20px;
    color: #4d4d4d;
}
.bidContent .b-statistics p:nth-child(1) {
    border-right: 1px solid #dbdbdb;
}
.bidContent .b-statistics p small {
    font-size: 16px;
    color: #6c6c6c;
}
.bidContent .tit {
    font-size: 32px;
    color: #333333;
    line-height: 42px;
    font-weight: initial;
}
.bidContent .price {
    font-size: 18px;
    color: #4d4d4d;
    margin: 15px 0;
    text-align: left;
}
.bidContent .price b {
    font-size: 34px;
    color: #af2f24;
}
.bidContent .price small {
    font-size: 22px;
    font-weight: initial;
}
.bidContent .b-box1 {
    background: #f3f3f3;
    border-radius: 5px;
    height: 410px;
}
.bidContent .startTime {
    background-image: -moz-linear-gradient(0deg, rgb(237, 207, 164) 0%, rgb(252, 244, 232) 100%);
    background-image: -webkit-linear-gradient(0deg, rgb(237, 207, 164) 0%, rgb(252, 244, 232) 100%);
    background-image: -ms-linear-gradient(0deg, rgb(237, 207, 164) 0%, rgb(252, 244, 232) 100%);
    height: 56px;
    border-radius: 5px;
    padding: 14px;
    line-height: 28px;
}
.bidContent .startTime .ico {
    display: block;
    height: 28px;
    float: left;
}
.bidContent .startTime .txt {
    font-size: 18px;
    color: #9b5d13;
    float: left;
    margin-left: 5px;
}
.bidContent .startTime .date {
    float: right;
    font-size: 16px;
    color: #905b29;
}
.bidContent .startTime .date span {
    display: inline-block;
    border-radius: 3px;
    background: #443b3b;
    font-weight: bold;
    color: #fff;
    width: 32px;
    text-align: center;
    margin: 0 3px;
}
.bidContent .b1-cont {
    width: 100%;
    padding: 20px 14px;
    position: relative;
}
.bidContent .b1-cont .ts {
    width: 80px;
    border-radius: 3px;
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;
    height: 28px;
    line-height: 28px;
    color: #fff;
    font-size: 16px;
}
.bidContent .b1-cont .ts.ts-no {
    background-image: linear-gradient(0deg, rgb(253, 202, 0) 0%, rgb(252, 160, 0) 100%);
    background-image: -moz-linear-gradient(0deg, rgb(253, 202, 0) 0%, rgb(252, 160, 0) 100%);
    background-image: -webkit-linear-gradient(0deg, rgb(253, 202, 0) 0%, rgb(252, 160, 0) 100%);
    background-image: -ms-linear-gradient(0deg, rgb(253, 202, 0) 0%, rgb(252, 160, 0) 100%);
}
.bidContent .b1-cont .ts.ts-start {
    background-image: linear-gradient(0deg, rgb(119, 191, 233) 0%, rgb(65, 163, 208) 100%);
    background-image: -moz-linear-gradient(0deg, rgb(119, 191, 233) 0%, rgb(65, 163, 208) 100%);
    background-image: -webkit-linear-gradient(0deg, rgb(119, 191, 233) 0%, rgb(65, 163, 208) 100%);
    background-image: -ms-linear-gradient(0deg, rgb(119, 191, 233) 0%, rgb(65, 163, 208) 100%);
}
.bidContent .b1-item {
    font-size: 18px;
    color: #4d4d4d;
    line-height: 30px;
    margin-bottom: 20px;
}
.bidContent .b1-item:last-child {
    margin-bottom: 0;
}
.bidContent .b1-item label {
    display: block;
    width: 75px;
    float: left;
    text-align-last: justify;
}
.bidContent .b1-item .pp {
    width: calc(100% - 95px);
    float: right;
}
.bidContent .b1-item .b1Bor {
    width: 280px;
    background: #fff;
    border: 1px solid #cbcbcb;
}
.bidContent .b1-item .cjPrice {
    height: 65px;
    position: relative;
    padding: 0 50px 0 25px;
    font-size: 24px;
    color: #9f9f9f;
    line-height: 63px;
}
.bidContent .b1-item .cjPrice span {
    display: block;
    position: absolute;
    right: -1px;
    border: 1px solid #cbcbcb;
    width: 35px;
    height: 33px;
    text-align: center;
    line-height: 28px;
    cursor: pointer;
    font-size: 28px;
    color: #4b4b4b;
}
.bidContent .b1-item .cjPrice span.plus {
    top: -1px;
}
.bidContent .b1-item .cjPrice span.minus {
    bottom: -1px;
}
.bidContent .b1-item .cjPrice span.cur {
    background: #af2f24;
    color: #fff;
}
.bidContent .b1-item .amount {
    height: 50px;
    line-height: 48px;
    font-size: 18px;
    color: #4d4d4d;
}
.bidContent .b1-item .amount input {
    display: block;
    border: 0;
    float: left;
    width: calc(100% - 48px);
    height: 48px;
    padding-left: 24px;
    font-size: 24px;
    color: #9f9f9f;
}
.bidContent .b1-item .amount p {
    width: 48px;
    float: right;
    text-align: center;
}
.bidContent .b1-item-start .cjPrice,
.bidContent .b1-item-start .cjPrice span,
.bidContent .b1-item-start .amount,
.bidContent .b1-item-start .amount input {
    border-color: #af2f24;
    color: #af2f24;
}
.bidContent .b1-item .b1Btn {
    display: block;
    width: 280px;
    height: 50px;
    border-radius: 8px;
    text-align: center;
    line-height: 50px;
	/* a8a8a8 */
    background: #a8a8a8;
    font-size: 22px;
    color: #fff;
}
.bidContent .b1-item .b1Btn.b1Btn-active {
    background: #af2f24;
}
.bidContent .b1Ts {
    background: #ffffe5;
    border: 1px solid #ffcc7f;
    font-size: 14px;
    color: #4d4d4d;
    width: 425px;
    height: 32px;
    line-height: 30px;
    padding: 0 10px;
}
.bidContent .b1Ts a {
    color: #327ad5;
    transition: 0.5s;
}
.bidContent .b1Ts a:hover {
    text-decoration: underline;
}

.bidContent .b-box2 {
    border: 1px solid #ededed;
    padding: 25px 45px 15px;
    font-size: 16px;
    color: #000000;
    margin: 25px 0;
    text-align: left;
}
.bidContent .b-box2 p {
    width: 25%;
    float: left;
    line-height: 25px;
    margin-bottom: 10px;
}
.bidContent .b-box2 p:last-child {
    width: 100%;
}

.bidContent .b-head {
    border: 1px solid #eeeeee;
    border-bottom: 1px solid #ec2828;
    background: #f8f8f8;
}
.bidContent .b-head a {
    display: block;
    float: left;
    padding: 0 25px;
    font-weight: bold;
    line-height: 45px;
    color: #616161;
    transition: 0.5s;
}
.bidContent .b-head a:hover,
.bidContent .b-head a.active {
    background: #ec2828;
    color: #fff;
}

.bidContent .b-box3 {
    padding: 40px 25px 0;
}
.bidContent .b-box3 .bt1 {
    background: #edfaff;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    color: #106a95;
    line-height: 55px;
}
.bidContent .b-box3 article {
    border-bottom: 1px solid #ededed;
    margin-bottom: 65px;
    font-size: 16px;
    color: #000;
    line-height: 25px;
    padding: 18px;
}

/* 缴纳保证金弹窗 */
.tcc {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 199;
}
.cash-popUp {
    background: #fff;
    border-radius: 10px;
    margin: auto auto;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 200;
    width: 31.25%;
    height: 84.656vh;
    padding: 4.255vh 3.385% 0;
    overflow: hidden;
}
.cash-popUp .cpImg {
    display: block;
    height: 9.735vh;
    margin: 0 auto;
}
.cash-popUp .cpTit {
    text-align: center;
    font-size: 2.751vh;
    color: #000000;
    line-height: 3.704vh;
    margin: 5px 0 3.175vh;
}
.cash-popUp .cpItem {
    position: relative;
    margin-bottom: 15px;
    color: #000000;
}
.cash-popUp .cpItem label {
    display: block;
    float: left;
    font-size: 2.328vh;
    line-height: 6.561vh;
    width: 65px;
}
.cash-popUp .cpItem input {
    display: block;
    width: calc(100% - 65px);
    float: right;
    padding: 0 70px 0 25px;
    border: 1px solid #dddddd;
    font-size: 2.328vh;
    height: 6.561vh;
}
.cash-popUp .cpItem span {
    display: block;
    line-height: 6.561vh;
    width: 70px;
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;
    font-size: 1.905vh;
}
.cash-popUp .cpBtn {
    width: 100%;
    height: 6.561vh;
    background: #af2f24;
    border-radius: 5px;
    text-align: center;
    color: #fff;
    line-height: 6.561vh;
    display: block;
    font-size: 2.54vh;
    margin: 3.175vh 0;
}
.cash-popUp .cpBtn img {
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
    height: 3.175vh;
}
.cash-popUp .cpSum {
    font-size: 2.963vh;
    color: #000000;
}
.cash-popUp .cpSum b {
    color: #af2f24;
    display: block;
    float: right;
}
.cash-popUp .cpSum small {
    font-size: 2.328vh;
}
.cash-popUp .cpSum span {
    font-size: 3.598vh;
}
.cash-popUp .ts {
    display: inline-block;
    font-size: 14px;
    color: #4d4d4d;
    background: #ffffe5;
    border: 1px solid #ffcc7f;
    line-height: 28px;
    padding: 0 15px;
    margin: 1.587vh 0 4.762vh;
}
.cash-popUp .cpAccount {
    width: 370px;
    border: 1px solid #b07b40;
    border-radius: 5px;
    overflow: hidden;
    text-align: center;
    margin: 0 auto;
}
.cash-popUp .cpAccount b {
    display: block;
    background: #b07b40;
    font-size: 2.54vh;
    color: #fff;
    line-height: 4.762vh;
}
.cash-popUp .cpAccount p {
    padding: 1.587vh 0;
    font-size: 2.328vh;
    color: #000000;
    line-height: 3.704vh;
}
.cash-popUp .gb {
    display: block;
    width: 25px;
    height: 25px;
    background: url(../../assets/images/ico16.png) center center no-repeat;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}

/* 出价成功弹窗 */
.succeed-popUp {
    width: 22.135vw;
    height: 31.746vh;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 200;
    padding-top: 8.995vh;
    margin: auto auto;
}
.succeed-popUp img {
    display: block;
    margin: 0 auto;
    width: 9.735vh;
}
.succeed-popUp p {
    font-size: 3.175vh;
    color: #000000;
    line-height: 4.233vh;
    margin-top: 10px;
    text-align: center;
}
.succeed-popUp .gb {
    display: block;
    width: 25px;
    height: 25px;
    background: url(../../assets/images/ico16.png) center center no-repeat;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}

/* 竞拍记录 */
.b-auction {
    margin: 35px 0;
}
.b-auction h3 {
    border-left: 8px solid #af2f24;
    height: 35px;
    line-height: 35px;
    padding-left: 20px;
    font-size: 32px;
    color: #333333;
    margin-bottom: 25px;
}
.b-auction table {
    font-size: 18px;
    color: #333333;
    text-align: center;
}
.b-auction table th {
    background: #af2f24;
    color: #fff;
    font-weight: initial;
}
.b-auction table tr,
.b-auction table td,
.b-auction table th {
    cursor: default;
    font-size: 18px;
    line-height: 30px;
    transition: 0.5s;
    padding: 12px 0;
}
.b-auction table tr td {
    width: 15%;
}
.b-auction table tr td:nth-child(1) {
    width: 40%;
}
.b-auction table .my {
    color: #24af38;
}
.b-auction table .my span {
    display: inline-block;
    background: #daecdd;
    border-radius: 15px 0 15px 0;
    font-size: 14px;
    line-height: 25px;
    padding: 0 10px;
}
.b-auction table .fist {
    color: #af2f24;
}
.b-auction table .fist span {
    display: inline-block;
    background: #f6e1df;
    border-radius: 15px 0 15px 0;
    font-size: 14px;
    line-height: 25px;
    padding: 0 10px;
}

@media screen and (max-width: 1600px) {
    .bidContent .pic {
        height: 430px;
    }
    .bidContent .tit {
        font-size: 26px;
        line-height: 35px;
        text-align: left;
    }
}
@media screen and (max-width: 1366px) {
    .bidContent .pic {
        height: 430px;
    }
    .cash-popUp .cpAccount {
        width: 100%;
    }
}
.pop_box{
		display: flex;
		flex-direction: column;
		/* align-items: center; */
	}
	.pop_image_box{
		display: flex;
		align-items: center;
		flex-direction: column;
		align-items: center;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 30px;
		color: #000;
	}
	.pop_image_box img{
		display: block;
		margin-bottom: 10px;
		width: 60px;
		height: 60px;
	}
	.input_box{
		margin-bottom: 10px;
		width: 100%;
		border: 1px solid #dddddd; 
	}
	.pop_btn{
		width:100%;
		height:45px;
		line-height:45px; 
		font-weight: bold;
		text-align:center;
		border-radius: 4px;
		color:#fff;
		font-size:14px;
		margin: 15px 0px 0px 0px;
		background-color:#af2f24;
	}
	
	/deep/ .el-dialog__body{
		padding: 20px !important;
	}
	/deep/ .el-dialog__header{
		padding: 0px !important;
	}
	.pop_tip{
		font-size:8px;
		padding: 2px 7px;
		background-color: #ffffe5;
		border: 1px solid #ffcc7f;
		width: 65%;
		margin-bottom: 20px;
	}
	.pop_address_box{
		width: 70%;
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		margin-bottom: 10px;
		border: 1px solid #b07b40;
	}
	.pop_address{
		padding: 3px;
		font-size: 15px;
		font-weight: bold;
		background-color: #b07b40;
		color: #fff;
		margin-bottom: 7px;
	}
	.pop_address_item{
		font-size: 15px;
		text-align: center;
		margin-bottom: 7px;
		color: #000;
	}
	 .dialog .input_box .el-input-group__append{
		background-color: #FFF !important;
		border: none !important;
		color: red;
	}
	.input_box .el-input__inner, .el-input-group__prepend{
		padding: 0px 15px;
	}
	.input_box .el-input-group__append{
		background-color: #FFF !important;
		border: none !important;
		color: #000;
	}
	.active{
		background-color: #f8f8f8;
	}
	.bzj_box{
		width: 100%;
		text-align: center;
		font-size: 25px;
		color:#af2f24;
		
	}
	.index_dot{
		width: 10px;
		height: 10px;
		position: absolute;
		right: 5px;
		top: 5px;
		border-radius: 50%;
		background-color: #af2f24;
	}
	.disUoloadSty .el-upload--picture-card{
	  display:none    /* 上传按钮隐藏 */
	}
</style>



// WEBPACK FOOTER //
// src/views/bidding/biddingDetail.vue